const $inject = ['APP_CONFIG'];

const apiService = (APP_CONFIG) => {
  const service = {
    getUrl: getUrl,
  };

  return service;

  function getUrl(name, slugs) {
    return getFullUrl(APP_CONFIG.API[name].url, slugs);
  }

  function getFullUrl(apiUrl, slugs) {
    if(_.isFunction(apiUrl)) {
      return apiUrl(slugs);
    }

    return apiUrl;
  }
};

apiService.$inject = $inject;

export default apiService;



// WEBPACK FOOTER //
// ./src/services/apiService.js